import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Channel } from '@app/shared/interfaces/channel';
import { AppConfig } from '@config/app.config';
import { ChannelsRepository } from '@core/repositories/channels.repository';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiChannelsRepository implements ChannelsRepository {
  public url = this.appConfig.URL + '/segments/';

  constructor(public appConfig: AppConfig, public http: HttpClient) {}

  getItems(): Observable<any> {
    return this.http.get(this.url);
  }

  add(channel: Channel): Observable<any> {
    const data = {
      data: {
        id: channel.id,
        type: 'Segment',
        attributes: {
          name: channel.name
        }
      }
    };
    return this.http.post(this.url, data);
  }

  edit(channel: Channel): Observable<any> {
    const data = {
      data: {
        id: channel.id,
        type: 'Segment',
        attributes: {
          name: channel.name
        }
      }
    };
    return this.http.put(this.url, data);
  }

  delete(item: any): Observable<any> {
    return this.http.delete(this.url + item);
  }
}
